"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useSetState = function (initialState) {
    if (initialState === void 0) { initialState = {}; }
    var _a = react_1.useState(initialState), state = _a[0], set = _a[1];
    var setState = function (patch) {
        set(function (prevState) { return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch); });
    };
    return [state, setState];
};
exports.default = useSetState;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useSetState.js
// module id = 268
// module chunks = 17